/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from 'rebass';

import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';
import Truncator from '../../../components/Truncator';

import { formatDateTimestamp, rangeFormatter } from '../../../util/date';
import { getOrderTypeLabel } from '../../catalogs/constants';
import { truncatorProps } from '../../constants';

const getDirectShipValue = input => {
  switch (input?.toLowerCase()) {
    case 'yes':
      return 'true';
    case 'no':
      return 'false';
    default:
      return input;
  }
};

export const columnSortModifiersLinkedCatalogs = {
  id: null,
  salesOrg: null,
  groupName: null,
  name: null,
  seasons: { disabled: true },
  atOnceDate: { colId: 'atOnceStart' },
  futuresDate: { colId: 'futuresStart' },
  forecastDate: { colId: 'forecastStart' },
  crdDate: { colId: 'futuresCrd' },
  orderTypes: { disabled: true },
  directShip: null,
  createTimestamp: null,
  defaultSort: { createTimestamp: 'desc' }
};

export const columnFilterModifiersLinkedCatalogs = {
  id: { expression: 'Like' },
  salesOrg: { expression: 'Like' },
  groupName: { expression: 'Like' },
  name: { expression: 'Like' },
  seasons: {
    expression: 'Includes',
    value: input => {
      // correct the input season format. For example from SP22 to SP2022
      if (/^[a-zA-Z]{2}\d{2}$/.test(input)) {
        const season = input.substr(0, 2);
        const year = input.substr(2);

        return `${season}20${year}`;
      }

      return input;
    }
  },
  atOnceDate: { colId: 'atOnceStart' },
  futuresDate: { colId: 'futuresStart' },
  forecastDate: { colId: 'forecastStart' },
  crdDate: { colId: 'futuresCrd' },
  orderTypes: { expression: 'Includes' },
  directShip: { expression: '', value: input => getDirectShipValue(input) },
  owner: { expression: 'Like' }
};

export const getLinkedCatalogsColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog ID' tableInstance={tableInstance} align='right' />,
      width: 130,
      id: 'id',
      accessor: originalRow => ({ id: originalRow.id, shortId: originalRow.shortId }),
      Cell: ({ value: { shortId, id } }) => (
        <Link to={`/catalogs/edit/${id}`} className='catalogs__link'>
          {shortId || id?.substr(0, 7)}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Sales Org' tableInstance={tableInstance} />,
      width: 130,
      accessor: 'salesOrg'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Group Name' tableInstance={tableInstance} />,
      accessor: 'groupName',
      width: 350,
      Cell: ({ value }) =>
        value?.split?.(' ')?.length > 1 ? (
          value
        ) : (
          <Box>
            <Truncator value={value} {...truncatorProps} />
          </Box>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Name' tableInstance={tableInstance} />,
      width: 350,
      accessor: 'name',
      Cell: ({ value }) =>
        value?.split?.(' ')?.length > 1 ? (
          value
        ) : (
          <Box>
            <Truncator value={value} {...truncatorProps} />
          </Box>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Season' tableInstance={tableInstance} />,
      width: 120,
      accessor: 'seasons',
      Cell: ({ value }) => {
        const trimmedValues = value?.map(i => i?.slice(0, 2) + i?.slice(4));
        return trimmedValues.length === 0
          ? ''
          : `${trimmedValues[0]}${trimmedValues.length > 1 ? ` - ${trimmedValues[trimmedValues.length - 1]}` : ''}`;
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Order Type' tableInstance={tableInstance} />,
      width: 150,
      accessor: 'orderTypes',
      Cell: ({ value }) => value?.map(orderType => getOrderTypeLabel(orderType)).join(', ')
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Direct Ship' tableInstance={tableInstance} />,
      width: 135,
      accessor: 'directShip',
      Cell: ({ value }) => (value ? 'Yes' : 'No')
    },
    {
      Header: tableInstance => <ColumnFilterSort header='CRD Date' tableInstance={tableInstance} />,
      width: 130,
      id: 'crdDate',
      accessor: originalRow => ({ futuresCrd: originalRow.futuresCrd, forecastCrd: originalRow.forecastCrd }),
      Cell: ({ value: { futuresCrd, forecastCrd } }) => formatDateTimestamp(futuresCrd || forecastCrd)
    },
    {
      Header: tableInstance => <ColumnFilterSort header='At-Once Date' tableInstance={tableInstance} />,
      width: 150,
      accessor: ({ atOnceStart, atOnceEnd }) => ({ atOnceStart, atOnceEnd }),
      id: 'atOnceDate',
      Cell: ({ value: { atOnceStart, atOnceEnd } }) => rangeFormatter({ start: atOnceStart, end: atOnceEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Futures Date' tableInstance={tableInstance} />,
      width: 150,
      accessor: ({ futuresStart, futuresEnd }) => ({ futuresStart, futuresEnd }),
      id: 'futuresDate',
      Cell: ({ value: { futuresStart, futuresEnd } }) => rangeFormatter({ start: futuresStart, end: futuresEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Forecast Date' tableInstance={tableInstance} />,
      width: 160,
      accessor: ({ forecastStart, forecastEnd }) => ({ forecastStart, forecastEnd }),
      id: 'forecastDate',
      Cell: ({ value: { forecastStart, forecastEnd } }) => rangeFormatter({ start: forecastStart, end: forecastEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Owner' tableInstance={tableInstance} />,
      accessor: 'owner',
      Cell: ({ value }) => value?.split('@')[0]
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Created' tableInstance={tableInstance} />,
      width: 120,
      accessor: 'createTimestamp',
      Cell: ({ value }) => formatDateTimestamp(value)
    }
  ];
};
